import React, { useState } from 'react';
import { Button } from 'ui'; // Adjust the import path as necessary
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DimensionsConstants from 'constants/DimensionsConstants'
import { useUpdateProjectName } from '../hooks/projects/mutations'
import { useProjectModal } from '../contexts/ProjectModalContext'


const TITLE_WIDTH = DimensionsConstants.LEFT_WIDTH - 60;

const LeftSideProject = ({
  hasEditPermission,
  isOnUserPage,
  project,
  projectName,
  leftPadding,
}) => {
    const { showProjectModal } = useProjectModal();
    const updateProjectNameMutation = useUpdateProjectName();
    
    // Single source of truth - initialize with project name and keep it synced
    const [editableProjectTitle, setEditableProjectTitle] = useState(projectName || '');
    
    // Update local state when projectName prop changes (e.g., from server updates)
    React.useEffect(() => {
      setEditableProjectTitle(projectName || '');
    }, [projectName]);

    const nonInputStyle = {padding:"1px 0px 0px 2px", cursor: "default"}
    const titleStyle = {
        paddingLeft: leftPadding,
        paddingTop:"20px",
        paddingBottom:"20px",
        fontSize:"1.25em",
        color:"white",
        float:"left",
        width: "100%"
      }
      
  const handleTitleChange = (e) => {
    setEditableProjectTitle(e.target.value);
  };

    const onTitleBlur = () => {
        const trimmedTitle = editableProjectTitle.trim();
        if (trimmedTitle && project.name !== trimmedTitle) {
          // Update local state immediately to prevent flicker
          setEditableProjectTitle(trimmedTitle);
          updateProjectNameMutation.mutate({ 
            projectId: project.id, 
            name: trimmedTitle 
          });
        } else if (!trimmedTitle) {
          // If empty, restore the original project name
          setEditableProjectTitle(projectName || '');
        }
    }

    const onTitleFocus = () => {
        // Nothing needed here - we're always using editableProjectTitle
    }

    const saveTitle = () => {
        if (document.activeElement) {
            document.activeElement.blur();
        }
    }

    const onKeyDown = (e) => {
        if (e.key === 'Enter') {
            saveTitle();
        }
    }    

  return (
    <div style={titleStyle}>
      <div style={{ display: "flex", alignItems: "center" }}>
        <div style={{ width: `${TITLE_WIDTH}px` }}>
          {hasEditPermission && !isOnUserPage ? (
            <input
              style={{
                borderStyle: "none",
                outline: "none",
                width: "100%",
                background: "transparent",
              }}
              value={editableProjectTitle}
              onBlur={onTitleBlur}
              onChange={handleTitleChange}
              onFocus={onTitleFocus}
              onKeyDown={onKeyDown}
              placeholder="Untitled Project"
            />
          ) : (
            <div
              style={!projectName ? { color: "#727272", ...nonInputStyle } : nonInputStyle}
            >
              {projectName || "Untitled Project"}
            </div>
          )}
        </div>
        <Button
          variant="link"
          onClick={showProjectModal}
          style={{ padding: 0, display: "inline-flex", alignItems: "center" }}
        >
          <ExpandMoreIcon data-testid="ExpandMoreIcon" style={{ display: "block", color: "white", fontSize: 16 }} />
        </Button>
      </div>
      <div style={{ clear: "both" }} />
    </div>
  );
};

export default LeftSideProject;